<div class="modal fade" id="login-dialog" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    <i class="bi bi-box-arrow-in-right me-2"></i>
                    Log In
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <!-- Error message -->
                <div class="d-none alert">
                    
                </div>

                <!-- List of members -->
                <h5>Members</h5>
                <ul class="members-list list-group">
                    <li class="list-group-item">
                        <div class="w-100 d-flex flex-row justify-content-between align-items-center">
                            <span class="fs-5">freak532486</span>
                            <span>Owner</span>
                        </div>
                    </li>
                    <li class="list-group-item">
                        <div class="w-100 d-flex flex-row justify-content-between">
                            <span class="fs-5">DerKraut</span>
                            <span>Guest</span>
                        </div>
                    </li>
                </ul>

                <hr>

                <!-- Invite member -->
                <div class="form-group">
                    <label for="input-invite-member">Invite Member</label>
                    <div class="w-100 d-flex flex-row gap-2">
                        <input id="input-invite-member" type="text" class="form-control flex-grow-1" placeholder="Username">
                        <button id="btn-invite-member" class="btn btn-primary">Invite</button>
                    </div>
                </div>

                <hr>

                <!-- Rename-->
                 <h5>Rename ranking</h5>
                 <input id="input-ranking-name" type="text" class="form-control" placeholder="">
            </div>

            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal">
                    Cancel
                </button>
                <button
                    type="button"
                    class="dialog-primary-button btn btn-primary">
                    OK
                </button>
            </div>

        </div>
    </div>
</div>